import { createRoot, type Root } from 'react-dom/client'

type RootContainer = HTMLElement & { __appRoot?: Root }

/** Reuses the container's root, because a hot update that re-runs an entry would otherwise mount a second app beside the first. */
export function getAppRoot(container: HTMLElement): Root {
  const host = container as RootContainer
  host.__appRoot ??= createRoot(host)
  return host.__appRoot
}
